import { Link } from 'react-router-dom';
import CtaBand from '../components/CtaBand';
import Icon from '../components/Icon';
import Layout, { PageHero } from '../components/Layout';
import { SERVICES } from '../constants/content';

const DETAILS = {
  'Sign-In & Account Access': ['Password resets that never arrive', 'Two-step verification problems', 'Finding which email holds your account', 'Sorting out duplicate accounts'],
  'Family Tree Problems': ['Merging duplicate people safely', 'Fixing wrong relationships', 'Slow or blank tree viewers', 'Exporting and backing up your tree'],
  'DNA Kit & Results': ['Activating kits in the right account', 'Linking results to your tree', 'Organising matches into groups', 'Understanding estimate updates'],
  'App Updates & Syncing': ['Crashes after app updates', 'Edits not syncing between devices', 'Desktop software sync conflicts', 'Browser compatibility checks'],
  'Records & Search': ['Search strategies that work', 'Reviewing and accepting hints', 'Attaching records correctly', 'Reading difficult record images'],
  'Photos & Media': ['Uploads that fail or stall', 'Rotating and cropping images', 'Organising media by person', 'Downloading your photos safely'],
};

const NOT_DONE = [
  'We never ask for, store, or use your password.',
  'We cannot access, change, or recover accounts on your behalf — only Ancestry can do that.',
  'We do not process refunds or billing changes for Ancestry memberships.',
  'We do not offer legal, medical, or genetic-counselling advice about DNA results.',
];

export default function HelpsServicesPage() {
  return (
    <Layout>
      <PageHero
        eyebrow="Helps services"
        title="Independent help, one problem at a time"
        lead="Here is everything our technicians can guide you through — on any computer, phone, or tablet."
        crumbs={[{ label: 'Helps Services' }]}
      />

      <section className="section">
        <div className="container card-grid card-grid--2">
          {SERVICES.map((s) => (
            <article key={s.title} className="service-card service-card--wide">
              <span className="service-card__icon">
                <Icon name={s.icon} size={28} />
              </span>
              <div>
                <h2>{s.title}</h2>
                <p>{s.text}</p>
                <ul className="tick-list">
                  {DETAILS[s.title].map((d) => (
                    <li key={d}>
                      <Icon name="check" size={18} /> {d}
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="section section--soft">
        <div className="container checklist-grid">
          <div>
            <p className="eyebrow">Being clear</p>
            <h2>What we don’t do</h2>
            <p>
              We are an independent service, so some things can only be handled by Ancestry directly. If your issue
              needs Ancestry’s own team, we’ll tell you straight away and explain how to reach them.
            </p>
            <Link to="/disclaimer" className="btn btn--outline">
              Read our disclaimer
            </Link>
          </div>
          <ul className="checklist checklist--plain">
            {NOT_DONE.map((item) => (
              <li key={item}>
                <Icon name="shield" size={20} /> {item}
              </li>
            ))}
          </ul>
        </div>
      </section>

      <CtaBand />
    </Layout>
  );
}
